// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1995992b","977":"82bddb99"}[chunkId] + ".chunk.js";
};